import React from 'react';

export default function TabPane({ className, children }) {
  return <div className={`px-3 px-md-5 py-3 py-md-5 ${className}`}>{children}</div>;
}
